<template>
  <div class="animated fadeIn">
    <b-alert :variant="dismissibleType"
             dismissible
             :show="showDismissibleAlert"
             @dismissed="showDismissibleAlert=false">
      {{ errMsg }}
    </b-alert>
    <div>
      <b-card>
        <div slot="header">
          <strong>Acquisition Fee Markup</strong>
          <button class="btn btn-info ml-3" @click="saveOptions"><i title="Save" class="fa fa-save fa-lg text-white"></i> <strong class="text-white">Save</strong></button>
        </div>
        <b-row>
          <b-col md="4">
            <table aria-busy="false" class="table b-table table-striped table-bordered table-sm">
              <thead class="thead-light">
                <tr>
                  <th aria-colindex="1">Lender Name</th>
                  <th aria-colindex="2" style="width:20%;">Markup</th>
                  <th aria-colindex="3" style="width:20%;">Max Markup</th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="!marketOptions.length" class="b-table-empty-row">
                  <td><div role="alert" aria-live="polite"><div class="text-center my-2">No filter options loaded yet.</div></div></td>
                </tr>
                <tr v-for="(mp, mi) in marketOptions" :id=mi>
                  <td id="tdname">{{ mp.lenderName }}</td>
                  <td><b-form-input id="txtvalue" size="sm" type="text" v-model.number="mp.value" @change="nullOnEmpty(mp)"></b-form-input></td>
                  <td id="tdmax">{{ mp.maxmarkup }}</td>
                </tr>
              </tbody>
            </table>
          </b-col>
        </b-row>

      </b-card>
</div>

    <loading :show="boolLoading"
              :label="txtLoading">
    </loading>
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import loading from 'vue-full-loading'
import cSwitch from '../components/Switch'

export default {
  components: {
    loading,
    cSwitch
  },
  created () {
    axios.get('/api/bankfeemarkup/loaddata')
      .then(response => {
        this.boolLoading = false
        this.marketOptions = response.data.data
      })
      .catch(error => {
        if (error.response.status === 403) { this.$router.push('/login') }

        this.boolLoading = false
        this.errMsg = 'There was an error getting data : ' + error
        this.showDismissibleAlert = true
      })
  },
  data () {
    return {
      errMsg: '',
      dismissibleType: 'danger',
      showDismissibleAlert: false,
      boolLoading: false,
      txtLoading: 'Loading...',
      marketOptions: []
    }
  },
  methods: {
    saveOptions () {
      if (!this.marketOptions) {
        this.errMsg = 'Unknown error.'
        this.showDismissibleAlert = true
        return
      }

      for (var i = 0; i < this.marketOptions.length; i++) {
        if (this.marketOptions[i].value > this.marketOptions[i].maxmarkup) {
          this.errMsg = 'Cannot be greater than Max Markup'
          this.showDismissibleAlert = true
          this.dismissibleType = 'danger'
          return
        } else if (this.marketOptions[i].value < 0) {
          this.errMsg = 'Cannot be less than 0'
          this.showDismissibleAlert = true
          this.dismissibleType = 'danger'
          return
        }
      }

      this.boolLoading = true
      var obj = {}

      obj.data = this.marketOptions.map(a => Object.assign({}, a));

      for (var i = 0; i < obj.data.length; i++) {
        if (!obj.data[i].value) {
          obj.data[i].value = 0
        }
      }

      axios.post('/api/bankfeemarkup/save', obj)
        .then(response => {
          this.errMsg = 'Bank Fees Saved'
          this.dismissibleType = 'success'
          this.showDismissibleAlert = true
          this.boolLoading = false
        })
        .catch(error => {
          if (error.response.status === 403 && error.response.statusText.indexOf('403.1') === -1) { this.$router.push('/login') }

          console.log(error)
          this.boolLoading = false
          this.errMsg = 'There was an error saving data : ' + error
          this.showDismissibleAlert = true

          if (error.response.status == 403 && error.response.statusText.indexOf('403.1') !== -1) { this.errMsg = error.response.statusText.replace('403.1', '') }
        })
    },
    nullOnEmpty (o) {
      if (o.value === '') { o.value = null }
    }
  },
  mounted () {
    // boolLoading must be set to false on data() binding so that mount hooks the change
    this.boolLoading = true
  }
}
</script>



// WEBPACK FOOTER //
// src/views/BankFeeMarkup.vue